module.exports = __webpack_public_path__ + "img/gsb36.ece6ddbb.png";